/**
 * Tenant selection state. The room registry is per-8x8-tenant, so the console
 * holds a "current tenant" (remembered in localStorage) and a short recents list.
 * The tenant also rides the URL as `?tenant=` so deep links and refreshes work.
 */

const TENANT_KEY = 'spaces.admin.tenant';
const RECENTS_KEY = 'spaces.admin.tenant.recents';
const MAX_RECENTS = 6;

export function getTenant(): string | null {
    try {
        const t = localStorage.getItem(TENANT_KEY);

        return t && t.length > 0 ? t : null;
    } catch {
        return null;
    }
}

export function recents(): string[] {
    try {
        const raw = JSON.parse(localStorage.getItem(RECENTS_KEY) ?? '[]') as unknown;

        return Array.isArray(raw) ? raw.filter((t): t is string => typeof t === 'string') : [];
    } catch {
        return [];
    }
}

export function rememberTenant(tenant: string): void {
    try {
        localStorage.setItem(TENANT_KEY, tenant);
        const list = [tenant, ...recents().filter(t => t !== tenant)].slice(0, MAX_RECENTS);

        localStorage.setItem(RECENTS_KEY, JSON.stringify(list));
    } catch {
        // best-effort; ignore storage errors
    }
}

export function clearTenant(): void {
    try {
        localStorage.removeItem(TENANT_KEY);
    } catch {
        // ignore
    }
}
